// extracted by mini-css-extract-plugin
export default {"avatarContainer":"u8syr","avatarInitials":"_1mlyV","avatarInitialsOtoplus":"_3e5XC","avatar":"_2PuEJ","dropDownList":"qN4S9","redDotContainer":"IhzzE"};